export enum ClawbackType {
    Refinancing,
    TopUp
}
export interface Clawback {
    amount?: number;
    type?: ClawbackType;
    issuedOn?: string; // Date
}